/**
 * India — Digital & Business Solutions
 * Category-level data for /solutions/india
 * No individual detail pages at this stage; solutions/india is the landing.
 */

export const indiaSolutions = [
  {
    id: 'digital-solutions',
    slug: 'digital-solutions',
    title: 'Digital Solutions',
    tagline: 'Building your digital presence from the ground up',
    description:
      'We help Indian businesses establish and grow their digital footprint — from professional websites to search visibility and performance marketing.',
    services: [
      {
        title: 'Website Design & Development',
        desc: 'Professional, mobile-friendly websites that represent your brand and convert visitors into enquiries.',
      },
      {
        title: 'Search Engine Optimisation (SEO)',
        desc: 'Improve your search rankings and drive qualified organic traffic to your business.',
      },
      {
        title: 'Digital Marketing',
        desc: 'Data-driven campaigns across search, social and display — designed for measurable results.',
      },
    ],
  },
  {
    id: 'creative-solutions',
    slug: 'creative-solutions',
    title: 'Creative Solutions',
    tagline: 'A brand that stands apart, content that speaks',
    description:
      'From brand identity to day-to-day creative production, we help Indian businesses look as professional as they are.',
    services: [
      {
        title: 'Graphic Design',
        desc: 'Professional visual design for print, digital and social — built around your brand.',
      },
      {
        title: 'Branding',
        desc: 'Brand identity development including logo, colour, typography and usage guidelines.',
      },
      {
        title: 'Content & Creative Support',
        desc: 'Copywriting, content strategy and creative production for your marketing channels.',
      },
    ],
  },
  {
    id: 'business-support-india',
    slug: 'business-support',
    title: 'Business Support',
    tagline: 'Free your team for what matters most',
    description:
      'Reliable administrative and operational support so your team can focus on building the business, not managing paperwork.',
    services: [
      {
        title: 'Administrative Support',
        desc: 'Email management, scheduling, documentation and day-to-day business administration.',
        serviceSlug: 'administrative-support',
      },
      {
        title: 'Back Office Support',
        desc: 'Data entry, document processing, record management and back-office operations.',
        serviceSlug: 'back-office-operations',
      },
      {
        title: 'Virtual Assistance',
        desc: 'Dedicated remote support for business owners, directors and executives.',
        serviceSlug: 'virtual-assistance',
      },
      {
        title: 'Business Operations Support',
        desc: 'Project coordination, vendor management and operational workflow support.',
        serviceSlug: 'business-operations',
      },
    ],
  },
  {
    id: 'ecommerce-support-india',
    slug: 'ecommerce-support',
    title: 'E-Commerce Support',
    tagline: 'Manage and grow your online business',
    description:
      'Whether you sell on Amazon India, Flipkart, your own website or any other platform — we provide the operational support to run it professionally.',
    services: [
      {
        title: 'E-Commerce Operations',
        desc: 'Order management, fulfilment coordination and day-to-day e-commerce operations.',
      },
      {
        title: 'Marketplace Management',
        desc: 'Listing management, catalogue maintenance and account management on major marketplaces.',
      },
      {
        title: 'Customer Operations',
        desc: 'Customer queries, returns, complaints and after-sales support for your online store.',
        serviceSlug: 'customer-support',
      },
    ],
  },
];
